// generateTimeList('09:00', '18:00')
// string 타입으로 '00:00' 형태로 입력
export function generateCounselTimeList(startTime: string, endTime: string): string[] {
    const timeList = [];
    const [startHour, startMinute] = startTime.split(':').map(Number);
    const [endHour, endMinute] = endTime.split(':').map(Number);

    const start = new Date(0, 0, 0, startHour, startMinute);
    const end = new Date(0, 0, 0, endHour, endMinute);

    while (start <= end) {
        const hours = start.getHours().toString().padStart(2, '0');
        const minutes = start.getMinutes().toString().padStart(2, '0');
        timeList.push(`${hours}:${minutes}`);
        start.setMinutes(start.getMinutes() + 30);
    }

    return timeList;
}
